export namespace IOfferAction {
    export class GetToken {
        static readonly type = 'IOfferAction.GetToken';

        constructor(public token: string, public pesel: string) {
        }
    }

    export class GetOffer {
        static readonly type = 'IOfferAction.GetOffer';
    }

    export class AcceptOffer {
        static readonly type = 'IOfferAction.AcceptOffer';
    }

    export class CancelOffer {
        static readonly type = 'IOfferAction.CancelOffer';
    }

    export class PrintoutOffer {
        static readonly type = 'IOfferAction.PrintoutOffer';

        constructor(public id: number, public productId: number, public all: boolean) {
        }
    }

    export class PrintoutPolicy {
        static readonly type = 'IOfferAction.PrintoutPolicy';

        constructor(public id: number, public all: boolean) {
        }
    }

    export class PrintoutSummary {
        static readonly type = 'IOfferAction.PrintoutSummary';

        constructor(public id: number) {
        }
    }

    export class PayPolicy {
        static readonly type = 'IOfferAction.PayPolicy';

        constructor(public orderId: string) {
        }
    }
}
